import React, { useState } from "react";

function InputDiet({ label,getValue,value, ...props }, ref) {
  const [isEdit, setIsEdit] = useState(false);
  return (
    <>
      {isEdit ? (
        <>
          <input
            type="text"        
            className="bg-gray-50 mr-5 border sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter Your Diet..."
            ref={ref}
            {...props}
          />
          <button
          className="bg-green-500  p-2 text-lg rounded-md hover:opacity-70"  
           onClick={(e) => {
            e.preventDefault()
            setIsEdit(false)}}> save </button>
        </>
      ) : (
        <>
          <label className="block mr-5 w-full text-lg font-medium text-black">
          {getValue(value)}
          </label>
          <button
          className="bg-blue-600 p-2 rounded-md text-lg text-white" 
           onClick={(e) => {
            e.preventDefault()
            setIsEdit(true)}}>Edit</button>
        </>
      )}
    </>
  );
}

export default React.forwardRef(InputDiet);
